module.exports = __webpack_public_path__ + "static/hero-index-main-1cc101f6a742bded9ce006f038d90497.png";